import React from "react";
import PropTypes from "prop-types";
import { VESSEL_TYPE } from "../../../../constants/constants";
import { useSelector } from "react-redux";
import { getDashboardCharts } from "../../../../model/slice/customDashboardSlice";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Virtuoso } from "react-virtuoso";
import { AddButton } from "../../../common/addButton";
import TrendIcon from "../../../../../assets/images/customDashboard/TrendIcon.svg";
import { createDashboardChartsList } from "../../dashboardUtil";
import { useTranslation } from "react-i18next";
import {
  addCustomTrendItem,
  checkTrendGraphExist,
  removeTrendGraphItem,
} from "./addTrendGraphHelper";
import DeleteIcon from "@mui/icons-material/Delete";

export const AddTrendGraphs = (props) => {
  const { currentVessel, setSelectedDashboard, existingTrendGraphIds } = props;
  const { t } = useTranslation();
  const isSepVessel = currentVessel.vesselType === VESSEL_TYPE.SEP;
  const customCharts = useSelector(getDashboardCharts);
  const chartsList = createDashboardChartsList(currentVessel, customCharts);
  const numberOfTrendGraphs = existingTrendGraphIds.filter((e) => e).length;
  const MAX_NUMBER_OF_TREND_GRAPHS = 4;
  const isMaxNumberOfTrendGraphs = numberOfTrendGraphs >= MAX_NUMBER_OF_TREND_GRAPHS;

  return (
    <Stack spacing={1} sx={{ height: "calc(100% - 140px)" }}>
      <Typography sx={{ color: "white" }}>{"Add up to 4 Graphs"}</Typography>
      {/* virtual scroll */}
      <Virtuoso
        style={{ height: "100%" }}
        data={chartsList}
        itemContent={(_, chart) => {
          const isExist = checkTrendGraphExist(existingTrendGraphIds, chart);
          return (
            <Box
              key={chart.id}
              onClick={() => {
                if (isExist) {
                  removeTrendGraphItem(chart.id, setSelectedDashboard);
                } else {
                  if (isMaxNumberOfTrendGraphs) return;
                  addCustomTrendItem(isSepVessel, chart, setSelectedDashboard);
                }
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "12px",
                border: "1px solid rgba(40, 182, 199, 0.7)",
                padding: "0 0 0 6px",
                marginBottom: "8px",
                height: "35px",
                width: "100%",
                cursor: isMaxNumberOfTrendGraphs ? "default" : "pointer",
                color: "white",
                opacity: isExist || isMaxNumberOfTrendGraphs ? 0.4 : 1,
              }}
            >
              <Box component={"div"} sx={{ display: "flex", alignItems: "center" }}>
                <img
                  src={TrendIcon}
                  style={{ height: "24px", width: "24px", color: "rgba(40, 182, 199, 0.7)" }}
                />
                <Tooltip title={t(chart.name)} placement="left" sx={{ fontSize: "14px" }}>
                  <Typography
                    variant="body2"
                    sx={{
                      marginLeft: "4px",
                      width: "250px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {t(chart.name)}
                  </Typography>
                </Tooltip>
              </Box>
              <div>
                {isExist ? (
                  <IconButton sx={{ color: "white" }}>
                    <DeleteIcon />
                  </IconButton>
                ) : (
                  <AddButton onClickHandler={() => {}} disabled={false} />
                )}
              </div>
            </Box>
          );
        }}
      />
    </Stack>
  );
};

AddTrendGraphs.propTypes = {
  currentVessel: PropTypes.object,
  setSelectedDashboard: PropTypes.func,
  existingTrendGraphIds: PropTypes.arrayOf(PropTypes.string),
};
